import type { KftApiDefaultResponse } from '~/composables/types/kft-api'
import type { KftDynamicContentMetrics } from '~/utils/kftApiUtils'
import {
  convertISO2Locale,
  convertLocaleIntoBCP47,
} from '~/utils/localeHelpers'

const FETCH_TIMEOUT_MS = 10_000

export const useDynamicContentMetrics = () => {
  const { locale } = useI18n()
  const config = useRuntimeConfig()
  const { apiBaseURL } = config.public

  const fetchDynamicContentMetrics = async (
    resource: string,
    slug: string
  ): Promise<KftDynamicContentMetrics | null> => {
    const localeBCP47 = convertLocaleIntoBCP47(locale.value)
    const localeISO2 = convertISO2Locale(locale.value)

    try {
      const response = await $fetch<
        KftApiDefaultResponse<KftDynamicContentMetrics>
      >(`/v1/store/metrics/${resource}/${slug}`, {
        baseURL: apiBaseURL as string,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': `${localeBCP47},${localeISO2}`,
        },
        timeout: FETCH_TIMEOUT_MS,
      })
      return response?.data ?? null
    } catch {
      return null
    }
  }

  return { fetchDynamicContentMetrics }
}
